"use strict";

import { secureEmailConstants } from "../_constants";

export const secureEmailSendMailRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SEND_REQUEST,
    payload,
  };
};

export const secureEmailSendMailComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SEND_COMPLETE,
    payload,
  };
};

export const secureEmailSendMailError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SEND_ERROR,
    payload,
  };
};

export const secureEmailSendInitiateRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SEND_INITIATE_REQUEST,
    payload,
  };
};

export const secureEmailSendInitiateComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SEND_INITIATE_COMPLETE,
    payload,
  };
};

export const secureEmailSendInitiateError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SEND_INITIATE_ERROR,
    payload,
  };
};

export const secureEmailSaveToDraftRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SAVE_TO_DRAFT_REQUEST,
    payload,
  };
};

export const secureEmailSaveToDraftComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SAVE_TO_DRAFT_COMPLETE,
    payload,
  };
};

export const secureEmailSetDraftValues = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SET_DRAFT_VALUES,
    payload,
  };
};

export const secureEmailSaveToDraftError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_SAVE_TO_DRAFT_ERROR,
    payload,
  };
};

export const secureEmailDraftClear = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_DRAFT_CLEAR,
    payload,
  };
};

export const secureMailClearData = () => {
  return {
    type: secureEmailConstants.SECURE_EMAIL_CLEAR_DATA,
  };
};

export const secureMailListRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_LIST_REQUEST,
    payload,
  };
};

export const secureMailListComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_LIST_COMPLETE,
    payload,
  };
};

export const secureMailListError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_LIST_ERROR,
    payload,
  };
};

export const secureMailDeleteMailRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_DELETE_REQUEST,
    payload,
  };
};

export const secureMailDeleteMailComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_DELETE_COMPLETE,
    payload,
  };
};

export const secureDeleteMailError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_DELETE_ERROR,
    payload,
  };
};

export const secureMailMessageListRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_MESSAGE_LIST_REQUEST,
    payload,
  };
};
export const secureMailMessageListComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_MESSAGE_LIST_COMPLETE,
    payload,
  };
};
export const secureMailMessageListError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_MESSAGE_LIST_ERROR,
    payload,
  };
};

export const secureMailReplyRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_REPLY_REQUEST,
    payload,
  };
};
export const secureMailReplyComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_REPLY_COMPLETE,
    payload,
  };
};
export const secureMailReplyError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_REPLY_ERROR,
    payload,
  };
};

export const secureMailSingleNotifyRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_SINGLE_NOTIFY_REQUEST,
    payload,
  };
};
export const secureMailSingleNotifyComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_SINGLE_NOTIFY_COMPLETE,
    payload,
  };
};
export const secureMailSingleNotifyError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_SINGLE_NOTIFY_ERROR,
    payload,
  };
};

export const secureMailNotifyRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_NOTIFY_REQUEST,
    payload,
  };
};
export const secureMailNotifyComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_NOTIFY_COMPLETE,
    payload,
  };
};
export const secureMailSingleError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_NOTIFY_ERROR,
    payload,
  };
};

export const secureMailFileUploadRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_REQUEST,
    payload,
  };
};

export const secureMailFileUploadComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_COMPLETE,
    payload,
  };
};

export const secureMailFileUploadError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_ERROR,
    payload,
  };
};

export const secureMailFileDeleteRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_DELETE_REQUEST,
    payload,
  };
};

export const secureMailFileDeleteComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_DELETE_COMPLETE,
    payload,
  };
};

export const secureMailFileDeleteError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_DELETE_ERROR,
    payload,
  };
};

export const secureMailFileDownloadRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_DOWNLOAD_REQUEST,
    payload,
  };
};

export const secureMailFileDownloadComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_DOWNLOAD_COMPLETE,
    payload,
  };
};

export const secureMailFileDownloadError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_DOWNLOAD_ERROR,
    payload,
  };
};

export const secureMailSendOtpRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_SEND_OTP_REQUEST,
    payload,
  };
};

export const secureMailSendOtpComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_SEND_OTP_COMPLETE,
    payload,
  };
};

export const secureMailSendOtpError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_SEND_OTP_ERROR,
    payload,
  };
};

export const secureMailResendOtpRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_RESEND_OTP_REQUEST,
    payload: payload ?? {},
  };
};

export const secureMailResendOtpComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_RESEND_OTP_COMPLETE,
    payload,
  };
};

export const secureMailResendOtpError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_RESEND_OTP_ERROR,
    payload,
  };
};

export const secureMailMessageClosedRequest = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_MESSAGE_CLOSED_REQUEST,
    payload,
  };
};

export const secureMailMessageClosedComplete = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_MESSAGE_CLOSED_COMPLETE,
    payload,
  };
};

export const secureMailMessageClosedError = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_MESSAGE_CLOSED_ERROR,
    payload,
  };
};

export const secureMailClearMessageList = () => {
  return {
    type: secureEmailConstants.SECURE_MAIL_CLEAR_MESSAGE_LIST,
  };
};

export const fileUploadRemove = (payload) => {
  return {
    type: secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_REMOVE,
    payload,
  };
};
